// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"style__wrapper___Hq6xT"};


/*****************
 ** WEBPACK FOOTER
 ** ./app/components/userLogin/style.scss
 ** module id = 368
 ** module chunks = 0
 **/